var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29006 0.709778C0.900059 1.09978 0.900059 1.72978 1.29006 2.11978L5.17006 5.99978L1.29006 9.87978C0.900059 10.2698 0.900059 10.8998 1.29006 11.2898C1.68006 11.6798 2.31006 11.6798 2.70006 11.2898L7.29006 6.69978C7.68006 6.30978 7.68006 5.67978 7.29006 5.28978L2.70006 0.699778C2.32006 0.319778 1.68006 0.319778 1.29006 0.709778Z",
    fill: "#D1D6DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDisabled);
export default __webpack_public_path__ + "static/media/arrowRightDisabled.bdaa78faa01ec9543b3b9ec775268346.svg";
export { ForwardRef as ReactComponent };